var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"mt-sm-2 btn btn-link float-right d-flex align-items-center",attrs:{"to":"/notifications"}},[_c('i',{class:{ 'far fa-2x': true, unread: _vm.getUnreadNotifications.length > 0 }})])}
var staticRenderFns = []

export { render, staticRenderFns }